export const useDialogInit = () => {
  const { $eventBus } = useNuxtApp()

  const onHandleAlert = (callback: (value: IEventBusDialogAlert) => void) => {
    $eventBus?.on<'dialog:alert'>('dialog:alert', callback)
  }

  const offHandleAlert = (callback: (value: IEventBusDialogAlert) => void) => {
    $eventBus?.off<'dialog:alert'>('dialog:alert', callback)
  }

  const onHandleForceCloseAllTheDialog = (callback: () => void) => {
    $eventBus?.on<'dialog:close'>('dialog:close', callback)
  }

  const offHandleForceCloseAllTheDialog = (callback: () => void) => {
    $eventBus?.off<'dialog:close'>('dialog:close', callback)
  }

  const onHandleConfirm = (
    callback: (value: IEventBusDialogConfirm) => void,
  ) => {
    $eventBus?.on<'dialog:confirm'>('dialog:confirm', callback)
  }

  const offHandleConfirm = (
    callback: (value: IEventBusDialogConfirm) => void,
  ) => {
    $eventBus?.off<'dialog:confirm'>('dialog:confirm', callback)
  }

  return {
    onHandleAlert,
    offHandleAlert,
    onHandleConfirm,
    offHandleConfirm,
    onHandleForceCloseAllTheDialog,
    offHandleForceCloseAllTheDialog,
  }
}
